<template>
    <modal-wrapper modalClass="modal" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1>{{$t('modals.returned_documents.title')}}</h1>
        </div>
        <div class="modal__content no-side-margins">
            <div v-if="uploadErrors.length" class="alert--error" >
                <span v-for="err in uploadErrors" :key="err"> {{ err }} </span>
            </div>
            <div v-if="documentUploading">
                <div class="spinner"></div>
            </div>
            <returned-documents-table v-else-if="document" :originalDocument="document" />
            <form enctype="multipart/form-data" novalidate>
                <dropzone-with-loading-button :uploading="documentUploading" @fileSelectedEvent="onDocumentSelected($event)" :buttonText="$t('common.upload_file')" />
            </form>
        </div>
        <div class="modal__footer">
            <div class="actions">
                <button class="actions__action--save pull-right" @click="$modal.hide(name)">{{$t('common.done')}}</button>
            </div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';
    import ReturnedDocumentsTable from '@/components/tables/dashboard/ReturnedDocumentsTable';
    import DropzoneWithLoadingButton from '@/components/general/DropzoneWithLoadingButton';

    import { GET_DOCUMENTS } from '@/store/modules/documents';

    @Component({
        components: {
            ReturnedDocumentsTable,
            DropzoneWithLoadingButton,
        }
    })
    export default class ReturnedDocumentsModal extends Vue {
        name = 'returned-documents-modal';
        uploadErrors = [];
        documentUploading = false;
        document = {};

        beforeOpen(event) {
            this.uploadErrors = [];
            this.documentUploading = false;
            this.document = event.params.document;
        }

        get trajectory() {
            return this.$store.state.trajectory.trajectory;
        }

        onDocumentSelected(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.uploadDocument(files[0]);
        }

        uploadDocument(file) {
            this.uploadErrors = [];
            var formData = new FormData();
            formData.append('file', file, file.name);

            this.documentUploading = true;
            this.axios.post(`/trajectories/${this.trajectory.id}/files/${this.document.id}/returns`, formData).then(
                res => this.$notify.success(this.$t('notify.upload_success'))
            ).catch(
                err => {
                    if (err.status === 422 && err.errors) {
                        this.uploadErrors = err.errors;
                        this.$notify.error(this.$t('common.validation_error'));
                    } else {
                        this.$notify.error(this.$t('notify.upload_error'));
                    }
                }
            ).then(() => {
                this.documentUploading = false;
                this.$store.dispatch(GET_DOCUMENTS, {});
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/ReturnedDocumentsModal.vue